import styled from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'

export const Title = styled.div`
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.01em;
    font-family: AvenirBold;
    color: #555555;
    margin: 10px 0px;
    ${applyIPadOnlyStyle('color:white', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const RecordingInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: start;
    margin: 4vh 0 3vh;
    & > div {
        margin: 0px 5px;
    }
`

export const Icon = styled.div`
    background: #f3c520;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bolder;

    ::after {
        content: 'i';
    }
`

export const Text = styled.div`
    font-style: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #555555;
    font-family: Avenir;
    width: 70%;

    ${applyIPadOnlyStyle('color:white, font-size: 12px', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const CtaTitle = styled.p`
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: center;

    ${({ margin }) => `margin: ${margin}vh 0 2vh`};
    ${applyIPadOnlyStyle('color:white, font-size: 14px', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const InformationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    ${applyIPadOnlyStyle('height: unset', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`
